<template>
  <v-card 
    v-if="items.length > 0" 
    class="elevation-0"
  >
    <v-card-text>
      <div v-if="growth.series !== undefined && growth.series.length > 0">
        <vue-highcharts
          :options="growth"
          ref="lineCharts"
          style="width: 100%; height: 350px"
        />
      </div>
      <v-alert 
        v-else 
        :value="true" 
        type="warning"
      >
        Result not found.
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import VueHighcharts from "@/components/vueHighcharts.vue";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
highchartsMore(Highcharts);
import _ from "lodash";

export default {
  components: {
    VueHighcharts
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    chartType: {
      type: String,
      default: "column"
    },
    tooltipSplit: {
      type: Boolean,
      default: false
    },
    xAxisTitle: {
      type: String,
      default: null
    },
    yAxisTitle: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      growth: {
        chart: {
          backgroundColor: null,
          type: this.chartType,
          style: {
            fontFamily: "Roboto"
          }
        },
        title: {
          text: this.title
        },
        credits: {
          enabled: false
        },
        xAxis: {
          title: {
            text: this.xAxisTitle
          },
          crosshair: true,
          categories: []
        },
        legend: {
          shadow: false
        },
        yAxis: {
          title: {
            text: this.yAxisTitle
          }
        },
        tooltip: {
          split: false
        },
        plotOptions: {
          column: {
            stacking: "normal",
            fillOpacity: 0.5
          }
        },
        series: this.items
      }
    }
  },
  watch: {
    items: function (val) {
      console.log('series', val)
      this.growth.series = val
    },
    yAxisTitle: function (val) {
      this.growth.chart.type = val
    },
    title: function (val) {
      this.growth.title = val
    },
    categories: function (val) {
      if (val.length > 0) {
        this.growth.xAxis.categories = val
      }
    },
    yAxisTitle: function (val) {
      this.growth.yAxis.title = val
    },
    xAxisTitle: function (val) {
      this.growth.xAxis.title = val
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/stack_chart.vue